import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { IAlert } from 'src/app/core/dto';
import { QuickPanelService } from '../quick-panel.service';

@Component({
  selector: 'app-alert-licensing',
  templateUrl: './alert-licensing.component.html',
  styleUrls: ['./alert-licensing.component.scss'],
  imports: [RouterModule, FlexLayoutModule],
})
export class AlertLicensingComponent {
  @Input() alert: IAlert = {} as IAlert;
  constructor(public quickPanelService: QuickPanelService) {}
}
